import { useTranslation } from "react-i18next";
export default function ReportTitle({ title }: { title: string }) {
  const { t } = useTranslation();

  return (
    <div className="bg-[#fff] dark:bg-[#141414] p-4">
      <h3 className="text-[20px] font-medium mb-5">{t("reports")}</h3>
      <p>
        <span className="w-[118px] inline-block text-right pr-3">
          {t("reportType")}:
        </span>
        <span className="bg-[#0364FF1A] text-[#0364FF] h-8 inline-block leading-8 px-4 rounded-full text-xs !text-[14px] ml-2">
          {title}
        </span>
      </p>
    </div>
  );
}
